export default "__VITE_ASSET__DivPMaIJ__"